import React from 'react';
import { Col, Container, Row,Button, ButtonToolbar,} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/AssignUserForm';

/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const AssignUserForm = ({ t }) => (
  <Container>
    
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

AssignUserForm.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(AssignUserForm);
